import 'jquery';
import Pikaday from 'Pikaday';

const $uploadText = $('.js-image-upload-text');
const $uploader = $('.js-image-upload');
const $hidden = $('.js-pikaday-datepicker-hidden');

/* eslint-disable no-new, no-unused-vars */
const $picker = new Pikaday({
  field: $('.js-pikaday-datepicker')[0],
  theme: 'ryobi-pikaday',
  onSelect: (date) => {
    $hidden.val($picker.toString());
  },
});
/* eslint-enable no-new, no-unused-vars */

$(document).ready(() => {
  if ($uploader.length === 0 || $uploadText.length === 0) {
    return;
  }
  $uploadText.click(() => {
    $uploader.click();
  });
  $uploader.change(() => {
    $uploadText.val($uploader.val());
  });
});
